"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MasterValve = void 0;
const tslib_1 = require("tslib");
const datamodel_core_1 = require("@iotv/datamodel-core");
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const DefinitionAndHelpers_1 = require("../../DefinitionAndHelpers");
const ValveTypes_1 = require("../../DefinitionAndHelpers/Definitions/ValveTypes");
const Valve_1 = require("./Valve");
const typeName = 'MasterValve';
const OFFLINETHRESHOLDMS = iotv_v3_types_1.Milliseconds.DAY;
class MasterValve extends Valve_1.Valve {
    constructor(ob) {
        var _a, _b, _c, _d, _e, _f, _g;
        super({ ...ob, type: (_a = ob.type) !== null && _a !== void 0 ? _a : typeName });
        this.getStatus = (valve = this, mapper = this.nodeEdgeMapper) => {
            const status = [];
            const now = new Date();
            const lastSeen = valve.timestamp && new Date(valve.timestamp);
            if (lastSeen && isNaN(lastSeen === null || lastSeen === void 0 ? void 0 : lastSeen.getTime())) {
                status.push(ValveTypes_1.MasterValveState.UNSEEN);
            }
            if ((lastSeen === null || lastSeen === void 0 ? void 0 : lastSeen.getTime()) < now.getTime() - OFFLINETHRESHOLDMS) {
                status.push(ValveTypes_1.MasterValveState.OFFLINE);
            }
            if (valve.pause) {
                status.push(ValveTypes_1.MasterValveState.AREAPAUSED);
            }
            if (valve.disabled) {
                status.push(ValveTypes_1.MasterValveState.DISABLED);
            }
            if (valve.error && valve.error.length > 0) {
                status.push(ValveTypes_1.MasterValveState.ERROR);
            }
            if (valve.operating) {
                status.push(ValveTypes_1.MasterValveState.OPEN);
            }
            const parentPaddock = mapper && mapper.getAdjacentNodes(valve, { objectTypeId: 'Area' })[0];
            if ((parentPaddock === null || parentPaddock === void 0 ? void 0 : parentPaddock.pause) === true) {
                status.push(ValveTypes_1.MasterValveState.AREAPAUSED);
            }
            if (valve.incomingProgramme !== undefined && !(status.includes(ValveTypes_1.MasterValveState.DISABLED) || status.includes(ValveTypes_1.MasterValveState.AREAPAUSED))) {
                status.push(ValveTypes_1.MasterValveState.AWAITINGPROGRAMME);
            }
            if (status.length === 0) {
                status.push(ValveTypes_1.MasterValveState.ONLINE);
            }
            return status;
        };
        this.updateFromDeviceMessage = DefinitionAndHelpers_1.updateEntity.bind(this);
        this.name = (_b = ob.name) !== null && _b !== void 0 ? _b : '';
        this.calcStatus = ob ? this.getStatus(ob) : undefined;
        this.timestamp = Date.now();
        this.valveState = (_c = ob.valveState) !== null && _c !== void 0 ? _c : false;
        this.solenoidVoltage = ob.solenoidVoltage;
        this.solenoidVoltageEUI = (_d = ob.solenoidVoltageEUI) !== null && _d !== void 0 ? _d : null;
        this.desiredVoltage = (_e = ob.desiredVoltage) !== null && _e !== void 0 ? _e : DefinitionAndHelpers_1.DEFAULT_SOLENOID_VOLTAGE;
        this.mvcTimePadding = (_f = ob.mvcTimePadding) !== null && _f !== void 0 ? _f : 0;
        this.state = ob.state ? ob.state : null;
        this.associatedProgramme = (_g = ob.associatedProgramme) !== null && _g !== void 0 ? _g : null;
        this.incomingProgramme = ob.incomingProgramme;
        this.currentProgramme = ob.currentProgramme;
        this.updated_at = ob.updated_at;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            name: {
                type: 'String',
                editable: true,
                label: 'Name',
                name: 'name',
                description: 'Name of Master Valve',
            },
            mvcTimePadding: {
                type: 'Number',
                editable: true,
                label: 'Delay Start Time (m)',
                name: 'Delay Start Time (m)',
                limits: {
                    min: 0,
                    max: 5,
                },
            },
            comments: {
                type: 'String',
                editable: true,
                label: 'Comments',
                name: 'comments',
                description: 'Free text for info ',
            },
        };
    }
}
exports.MasterValve = MasterValve;
tslib_1.__decorate([
    (0, datamodel_core_1.enumerable)(false),
    tslib_1.__metadata("design:type", Function)
], MasterValve.prototype, "updateFromDeviceMessage", void 0);
